import {SegmentStatus} from '@Shared/Constants/SegmentStatus';

import type {BufferData} from '../Models/BufferData';

const hasSegmentInBufferingRangeExceededDownloadTimeout = (bufferData: BufferData, timeoutMs: number): boolean => {
    const currentTimeMs = Date.now();
    let isSegmentExceedingDownloadTimeout = false;

    for (const urlKey in bufferData.bufferingRangeMap) {
        if (!bufferData.bufferingRangeMap.hasOwnProperty(urlKey)) continue;

        const segment = bufferData.bufferingRangeMap[urlKey];

        if (
            segment.status === SegmentStatus.DOWNLOADING &&
            segment.requestTimeMs &&
            currentTimeMs - segment.requestTimeMs > timeoutMs
        ) {
            isSegmentExceedingDownloadTimeout = true;

            break;
        }
    }

    return isSegmentExceedingDownloadTimeout;
};

export {hasSegmentInBufferingRangeExceededDownloadTimeout};
